export default "__VITE_ASSET__Dn6UBQI0__"